import http from "../config/axios";

export async function getDealById({ dealId }:any) {
    try {
        const response = await http.request({
            method: "GET",
            url: `/restaurant_deal/detail/${dealId}`,
            headers: {
                'Content-Type': 'application/json',
            }
        });

        return response.data;
    } catch (error) {
        console.error("Erro ao buscar promoção:", error);
        throw error;
    }
}

export async function updateDeal({ dealId, requestBody }: any) {
    console.log("requestBody", requestBody);
    try {
        const response = await http.request({
            method: "PATCH",
            url: `/restaurant_deal/update/${dealId}`,
            headers: {
                'Content-Type': 'application/json',
            },
            data: requestBody
        });
        return response.data;
    } catch (error) {
        console.error("Erro ao atualizar promoção:", error);
        throw error;
    }
}


export async function updateDealStatus({ dealId, status }: any) {
    try {
        const response = await http.request({
            method: "PATCH",
            url: `/restaurant_deal/update_status/${dealId}`,
            headers: {
                'Content-Type': 'application/json',
            },
            data: { status }
        });
        return response.data;
    } catch (error) {
        console.error("Erro ao atualizar status da promoção:", error);
        throw error;
    }
}